'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var dateFns = require('date-fns');

function isUniqueDate(date, otherDates) {
    return !otherDates.some(function (otherDate) { return dateFns.compareDesc(date, otherDate) === 0; });
}

exports.isUniqueDate = isUniqueDate;
